import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LinkTvComponent } from './link-tv.component';

const routes: Routes = [
  {
    path: '',
    component: LinkTvComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class LinkTvRoutingModule {}

